import personnummer from 'personnummer.js';

function isValid(value) {
  const isValidSsn = personnummer.validate(value);

  return isValidSsn && value.replace('-', '').length === 12;
}

export default { isValid };
